S.text =
  {
      elements: {
          $text: null,
      },
      init()
      {
          var list = this.elements.$text.find('p');

          for (let i = 0; i < list.length; i++)
          {
              if ($(list[i]).text().replace(/\s+/g, '').length === 0)
              {
                  $(list[i]).remove();
              }
          }
          this.elements.$text.children().has('strong').addClass('is-list-item');
      },
  };
